import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './userContext';
import DefaultLoading from './common/DefaultLoading';
import ProfileLoadError from './components/ProfileLoadError';
import { getAuth } from 'firebase/auth';

const PrivateRoute = ({ children }) => {
  const { user, loading, userProfile, profileError } = useUser();
  const location = useLocation();

  // Source of truth for "is there a live auth session" = Firebase's own auth.currentUser.
  // React state can lag during hydration (bfcache, tab wake, token refresh), so falling back
  // to auth.currentUser avoids spurious redirects to /login while auth is still catching up.
  const authedUser = user || getAuth().currentUser;

  // Profile load failed but auth is still valid — show retry screen, don't kick to login.
  if (authedUser && profileError) {
    return <ProfileLoadError />;
  }

  // Still loading auth, or auth is resolved but profile fetch is in flight.
  if (loading || (authedUser && !userProfile)) {
    return <DefaultLoading />;
  }

  // Not logged in - redirect to login
  if (!authedUser) {
    return <Navigate to="/studio/login" replace state={{ from: location }} />;
  }

  // Enforce onboarding before any studio routes
  if (userProfile?.onboardingComplete === false && location.pathname !== '/studio/setup') {
    return <Navigate to="/studio/setup" replace state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
